import { combineActions, handleActions } from 'redux-actions'
import {
  updateForm,
  setFormAnswers,
  setSelectedTabs,
  unsetCurrentForm,
  setCurrentForm,
  updateFormAnswers,
  clearFormAnswers,
  updateAnswerStatus,
  updateReattachCount,
  resetFormsState,
  setSelectedRecord,
  addFormRecord,
  removeFormRecord,
  setDisplayAnswersMode,
  setSelectedUserId,
  setReadonlySelectedTabs,
} from '../actions'
import { ContentFormDetails, FormControlAnswer } from '../types'

const defaultState = {}

const currentForm = handleActions<
  Partial<
    | ContentFormDetails & {
        answers: FormControlAnswer[]
        selectedTabs?: number[]
        selectedRecord: number
      }
  >,
  any
>(
  {
    [updateForm.toString()](state, action) {
      return { ...action.payload, answers: [] }
    },
    [unsetCurrentForm.toString()](state, action) {
      return { ...action.payload }
    },
    [setFormAnswers.toString()](state, action) {
      return {
        ...state,
        answers: action.payload,
      }
    },
    [updateFormAnswers.toString()](state, action) {
      let answers
      if (state.answers?.length) {
        answers = [
          ...(state.answers ?? []).filter((item) => item.FormControlId !== action.payload.FormControlId),
          action.payload,
        ]
      } else {
        answers = [action.payload]
      }
      return {
        ...state,
        answers,
      }
    },
    [clearFormAnswers.toString()](state, action) {
      return {
        ...state,
        answers: state.answers?.filter((item) => item.Id !== action.payload.Id),
      }
    },
    [combineActions(setSelectedTabs, setReadonlySelectedTabs).toString()](state, action) {
      return {
        ...state,
        selectedTabs: [...action.payload],
      }
    },
    [setCurrentForm.toString()](state, action) {
      return action.payload
    },
    [updateAnswerStatus.toString()](state, action) {
      const { FormAnswerId, FormAnswerStatus, ApproverId, ApproverName, FormAnswerStatusCreatedOn } = action.payload

      return {
        ...state,
        answers: state.answers?.map((answer) =>
          answer.Id === FormAnswerId
            ? { ...answer, FormAnswerStatus, ApproverId, ApproverName, FormAnswerStatusCreatedOn }
            : answer
        ),
      }
    },
    [updateReattachCount.toString()](state, action) {
      return {
        ...state,
        ReattachedNumberOfTimes: state?.ReattachedNumberOfTimes ?? 0 + 1,
      }
    },
    [setSelectedRecord.toString()](state, action) {
      return {
        ...state,
        selectedRecord: action.payload,
      }
    },
    [combineActions(setSelectedUserId, setDisplayAnswersMode).toString()](state, action) {
      return {
        ...state,
        selectedRecord: 0,
      }
    },
    [addFormRecord.toString()](state, action) {
      return {
        ...state,
        Records: [...state.Records!, action.payload],
      }
    },
    [removeFormRecord.toString()](state, action) {
      return {
        ...state,
        Records: state.Records!.filter((rec) => rec.Id !== action.payload),
      }
    },
    [resetFormsState.toString()](state, action) {
      return defaultState
    },
  },
  defaultState
)

export default currentForm
